import { useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";

import { adaptPressTitleRegexInformation } from "./adaptPressTitleRegex.data";
import { pressTitleRegexApis } from "./pressTitleRegex.service";

export const usePressTitleRegexInformation = () => {
  const query = useSuspenseQuery({
    queryKey: [QUERY_KEYS.pressTitleRegexInformation],
    queryFn: async () => {
      const response =
        await pressTitleRegexApis.getPressTitleRegexInformation();
      return response.data;
    },
    select: (data) => adaptPressTitleRegexInformation(data),
  });

  return query;
};
